<template>
   <div>
        <div class="table-wrapper on-991" v-if="$i18n.locale=='en'">
            <div>
                <table>
                    <thead>
                        <tr class="dark-gray">
                            <td><span class="invisible">asdf</span></td>
                            <td colspan="2" class="font center white">SMTC</td>
                            <td colspan="2" class="font center white">AL KHATEM, IRAQ</td>
                            <td colspan="2" class="font center white">ZAIN BAHRAIN</td>
                        </tr>
                        <tr class="light-gray">
                            <td><span class="invisible">asdf</span></td>
                            <td class="skyBlue bolder end font ligest-gray">2020</td>
                            <td class="white bolder end font">2019</td>
                            <td class="skyBlue bolder end font ligest-gray">2020</td>
                            <td class="white bolder end font">2019</td>
                            <td class="skyBlue bolder end font ligest-gray">2020</td>
                            <td class="white bolder end font">2019</td>
                        </tr>
                        <tr class="light-gray">
                            <td colspan="3"><span class="invisible">asdf</span></td>
                            <td colspan="2" class="center white bolder">KD ’000</td>
                            <td colspan="2"><span class="invisible">asdf</span></td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="font skyBlue">Current assets</td>
                            <td class="end font ligest-gray">273,953</td>
                            <td class="end font">275,505</td>
                            <td class="end font ligest-gray">227,250</td>
                            <td class="end font">183,125</td>
                            <td class="end font ligest-gray">24,513</td>
                            <td class="end font">28,301</td>
                        </tr>
                        <tr>
                            <td class="font ">Non-current assets</td>
                            <td class="end font ligest-gray">2,006,262</td>
                            <td class="end font">1,969,074</td>
                            <td class="end font ligest-gray"> 759,855</td>
                            <td class="end font">733,288</td>
                            <td class="end font ligest-gray">76,777</td>
                            <td class="end font">67,081</td>
                        </tr>
                        <tr>
                            <td class="font ">Current liabilities</td>
                            <td class="end font ligest-gray">(441,261)</td>
                            <td class="end font">(365,481)</td>
                            <td class="end font ligest-gray"> (255,809)</td>
                            <td class="end font">(259,677)</td>
                            <td class="end font ligest-gray">(28,685) </td>
                            <td class="end font">(23,270)</td>
                        </tr>
                        <tr>
                            <td class="font ">Non-current liabilities</td>
                            <td class="end font ligest-gray">(1,132,073)</td>
                            <td class="end font">(1,547,096)</td>
                            <td class="end font ligest-gray"> (224,347)</td>
                            <td class="end font">(158,196)</td>
                            <td class="end font ligest-gray">(11,796)</td>
                            <td class="end font">(14,066)</td>
                        </tr>
                        <tr>
                            <td class="font skyBlue">Equity attributable to:</td>
                            <td class="ligest-gray"><span class="invisible">asdf</span></td>
                            <td class="end font"></td>
                            <td class="ligest-gray"><span class="invisible">asdf</span></td>
                            <td class="end font"></td>
                            <td class="ligest-gray"><span class="invisible">asdf</span></td>
                            <td class="end font"></td>
                        </tr>
                        <tr>
                            <td class="font ">- Owners of the Company</td>
                            <td class="end font ligest-gray">261,864</td>
                            <td class="end font">122,990</td>
                            <td class="end font ligest-gray">382,966</td>
                            <td class="end font">377,854</td>
                            <td class="end font ligest-gray">33,688</td>
                            <td class="end font">32,158</td>
                        </tr>
                        <tr>
                            <td class="font ">- Non-controlling interests</td>
                            <td class="end font ligest-gray"> 445,017</td>
                            <td class="end font">209,012</td>
                            <td class="end font ligest-gray">123,983</td>
                            <td class="end font">120,686</td>
                            <td class="end font ligest-gray">27,121</td>
                            <td class="end font">25,889</td>
                        </tr>
                        <tr>
                            <td class="font ">Revenue</td>
                            <td class="end font ligest-gray">647,258</td>
                            <td class="end font">679,887</td>
                            <td class="end font ligest-gray">288,939</td>
                            <td class="end font">327,167</td>
                            <td class="end font ligest-gray">50,384</td>
                            <td class="end font">50,644</td>
                        </tr>
                        <tr>
                            <td class="font ">Profit for the year</td>
                            <td class="end font ligest-gray">21,249</td>
                            <td class="end font">39,328</td>
                            <td class="end font ligest-gray">26,768</td>
                            <td class="end font">20,300</td>
                            <td class="end font ligest-gray">4,388</td>
                            <td class="end font">4,243</td>
                        </tr>
                        <tr>
                            <td class="font ">Other comprehensive income</td>
                            <td class="end font ligest-gray">(6,368)</td>
                            <td class="end font">(8,206) </td>
                            <td class="end font ligest-gray">-</td>
                            <td class="end font">-</td>
                            <td class="end font ligest-gray"> -</td>
                            <td class="end font">-</td>
                        </tr>
                        <tr>
                            <td class="font black ">Total comprehensive income</td>
                            <td class="end font skyBlue ligest-gray ">14,881</td>
                            <td class="end font skyBlue">31,122</td>
                            <td class="end font skyBlue ligest-gray">26,768</td>
                            <td class="end font skyBlue">20,300</td>
                            <td class="end font skyBlue ligest-gray"> 4,388</td>
                            <td class="end font skyBlue">4,243</td>
                        </tr>
                        <tr>
                            <td class="font skyBlue">Total comprehensive income attributable to:</td>
                            <td class="ligest-gray"><span class="invisible">asdf</span></td>
                            <td class="end font"></td>
                            <td class="ligest-gray"><span class="invisible">asdf</span></td>
                            <td class="end font"></td>
                            <td class="ligest-gray"><span class="invisible">asdf</span></td>
                            <td class="end font"></td>
                        </tr>
                        <tr>
                            <td class="font ">- Company’s shareholders</td>
                            <td class="end font ligest-gray"> 5,512</td>
                            <td class="end font">11,529</td>
                            <td class="end font ligest-gray">18,521</td>
                            <td class="end font">14,498</td>
                            <td class="end font ligest-gray">2,431</td>
                            <td class="end font">2,351</td>
                        </tr>
                        <tr>
                            <td class="font ">- Non-controlling interests</td>
                            <td class="end font ligest-gray">9,369</td>
                            <td class="end font">19,593</td>
                            <td class="end font ligest-gray">8,247</td>
                            <td class="end font">5,802</td>
                            <td class="end font ligest-gray">1,957</td>
                            <td class="end font">1,892</td>
                        </tr>
                        <tr>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font skyBlue ligest-gray ">14,881</td>
                            <td class="end font skyBlue">31,122</td>
                            <td class="end font skyBlue ligest-gray">26,768</td>
                            <td class="end font skyBlue">20,300</td>
                            <td class="end font skyBlue ligest-gray"> 4,388</td>
                            <td class="end font skyBlue">4,243</td>
                        </tr>
                        <tr>
                            <td class="font ">Cash dividend paid to non-controlling Interests</td>
                            <td class="end font ligest-gray">-</td>
                            <td class="end font">-</td>
                            <td class="end font ligest-gray">(4,376)</td>
                            <td class="end font">(3,666)</td>
                            <td class="end font ligest-gray">(890)</td>
                            <td class="end font">(629)</td>
                        </tr>
                        <tr>
                            <td class="font ">Net cash flow from operating activities</td>
                            <td class="end font ligest-gray">313,350</td>
                            <td class="end font">322,871</td>
                            <td class="end font ligest-gray">16,605</td>
                            <td class="end font">113,242</td>
                            <td class="end font ligest-gray">17,819</td>
                            <td class="end font">17,949</td>
                        </tr>
                        <tr>
                            <td class="font ">Net cash flow from used in investing activities</td>
                            <td class="end font ligest-gray">(144,937)</td>
                            <td class="end font">(163,079)</td>
                            <td class="end font ligest-gray">(25,361)</td>
                            <td class="end font">(49,041)</td>
                            <td class="end font ligest-gray">(13,709) </td>
                            <td class="end font">(8,926)</td>
                        </tr>
                        <tr>
                            <td class="font ">Net cash flow (used in)/ from financing activities</td>
                            <td class="end font ligest-gray">(169,668)</td>
                            <td class="end font">(180,800) </td>
                            <td class="end font ligest-gray">34,287</td>
                            <td class="end font">(23,988)</td>
                            <td class="end font ligest-gray">(4,519)</td>
                            <td class="end font">(4,213)</td>
                        </tr>
                        <tr>
                            <td class="font ">Effects of exchange rate changes on cash and cash equivalents</td>
                            <td class="end font ligest-gray">247</td>
                            <td class="end font">(73)</td>
                            <td class="end font ligest-gray">(550)</td>
                            <td class="end font">(151)</td>
                            <td class="end font ligest-gray">(23)</td>
                            <td class="end font">(12)</td>
                        </tr>
                        <tr>
                            <td class="font ">Net (decrease)/ increase in cash flows</td>
                            <td class="end font ligest-gray">(1,255)</td>
                            <td class="end font">(21,008)</td>
                            <td class="end font ligest-gray">21,155</td>
                            <td class="end font">36,547</td>
                            <td class="end font ligest-gray">(1,299) </td>
                            <td class="end font">4,181</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- Arabic -->

        <div class="table-wrapper on-991" v-if="$i18n.locale=='ar'">
            <div>
                <table>
                    <thead>
                        <tr class="dark-gray">
                            <td><span class="invisible">asdf</span></td>
                            <td colspan="2" class="font center white">زين السعودية</td>
                            <td colspan="2" class="font center white">الخاتم، العراق</td>
                            <td colspan="2" class="font center white">زين البحرين</td>
                        </tr>
                        <tr class="light-gray">
                            <td><span class="invisible">asdf</span></td>
                            <td class="skyBlue bolder end font ligest-gray">2020</td>
                            <td class="white bolder end font">2019</td>
                            <td class="skyBlue bolder end font ligest-gray">2020</td>
                            <td class="white bolder end font">2019</td>
                            <td class="skyBlue bolder end font ligest-gray">2020</td>
                            <td class="white bolder end font">2019</td>
                        </tr>
                        <tr class="light-gray">
                            <td colspan="3"><span class="invisible">asdf</span></td>
                            <td colspan="2" class="center white bolder">ألف دينار كويتي</td>
                            <td colspan="2"><span class="invisible">asdf</span></td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="font skyBlue">موجودات متداولة</td>
                            <td class="end font ligest-gray">273,953</td>
                            <td class="end font">275,505</td>
                            <td class="end font ligest-gray">227,250</td>
                            <td class="end font">183,125</td>
                            <td class="end font ligest-gray">24,513</td>
                            <td class="end font">28,301</td>
                        </tr>
                        <tr>
                            <td class="font ">موجودات غير متداولة</td>
                            <td class="end font ligest-gray">2,006,262</td>
                            <td class="end font">1,969,074</td>
                            <td class="end font ligest-gray"> 759,855</td>
                            <td class="end font">733,288</td>
                            <td class="end font ligest-gray">76,777</td>
                            <td class="end font">67,081</td>
                        </tr>
                        <tr>
                            <td class="font ">مطلوبات متداولة</td>
                            <td class="end font ligest-gray">(441,261)</td>
                            <td class="end font">(365,481)</td>
                            <td class="end font ligest-gray"> (255,809)</td>
                            <td class="end font">(259,677)</td>
                            <td class="end font ligest-gray">(28,685) </td>
                            <td class="end font">(23,270)</td>
                        </tr>
                        <tr>
                            <td class="font ">مطلوبات غير متداولة</td>
                            <td class="end font ligest-gray">(1,132,073)</td>
                            <td class="end font">(1,547,096)</td>
                            <td class="end font ligest-gray"> (224,347)</td>
                            <td class="end font">(158,196)</td>
                            <td class="end font ligest-gray">(11,796)</td>
                            <td class="end font">(14,066)</td>
                        </tr>
                        <tr>
                            <td class="font skyBlue">حقوق ملكية عائدة لـ</td>
                            <td class="ligest-gray"><span class="invisible">asdf</span></td>
                            <td class="end font"></td>
                            <td class="ligest-gray"><span class="invisible">asdf</span></td>
                            <td class="end font"></td>
                            <td class="ligest-gray"><span class="invisible">asdf</span></td>
                            <td class="end font"></td>
                        </tr>
                        <tr>
                            <td class="font ">مالكي الشركة</td>
                            <td class="end font ligest-gray">261,864</td>
                            <td class="end font">122,990</td>
                            <td class="end font ligest-gray">382,966</td>
                            <td class="end font">377,854</td>
                            <td class="end font ligest-gray">33,688</td>
                            <td class="end font">32,158</td>
                        </tr>
                        <tr>
                            <td class="font ">حصص غير مسيطرة</td>
                            <td class="end font ligest-gray"> 445,017</td>
                            <td class="end font">209,012</td>
                            <td class="end font ligest-gray">123,983</td>
                            <td class="end font">120,686</td>
                            <td class="end font ligest-gray">27,121</td>
                            <td class="end font">25,889</td>
                        </tr>
                        <tr>
                            <td class="font ">إيرادات</td>
                            <td class="end font ligest-gray">647,258</td>
                            <td class="end font">679,887</td>
                            <td class="end font ligest-gray">288,939</td>
                            <td class="end font">327,167</td>
                            <td class="end font ligest-gray">50,384</td>
                            <td class="end font">50,644</td>
                        </tr>
                        <tr>
                            <td class="font ">ربح السنة</td>
                            <td class="end font ligest-gray">21,249</td>
                            <td class="end font">39,328</td>
                            <td class="end font ligest-gray">26,768</td>
                            <td class="end font">20,300</td>
                            <td class="end font ligest-gray">4,388</td>
                            <td class="end font">4,243</td>
                        </tr>
                        <tr>
                            <td class="font ">الدخل الشامل الآخر</td>
                            <td class="end font ligest-gray">(6,368)</td>
                            <td class="end font">(8,206) </td>
                            <td class="end font ligest-gray">-</td>
                            <td class="end font">-</td>
                            <td class="end font ligest-gray"> -</td>
                            <td class="end font">-</td>
                        </tr>
                        <tr>
                            <td class="font black ">مجموع الدخل الشامل</td>
                            <td class="end font skyBlue ligest-gray ">14,881</td>
                            <td class="end font skyBlue">31,122</td>
                            <td class="end font skyBlue ligest-gray">26,768</td>
                            <td class="end font skyBlue">20,300</td>
                            <td class="end font skyBlue ligest-gray"> 4,388</td>
                            <td class="end font skyBlue">4,243</td>
                        </tr>
                        <tr>
                            <td class="font skyBlue">مجموع الدخل الشامل العائد لـ</td>
                            <td class="ligest-gray"><span class="invisible">asdf</span></td>
                            <td class="end font"></td>
                            <td class="ligest-gray"><span class="invisible">asdf</span></td>
                            <td class="end font"></td>
                            <td class="ligest-gray"><span class="invisible">asdf</span></td>
                            <td class="end font"></td>
                        </tr>
                        <tr>
                            <td class="font ">مساهمي الشركة</td>
                            <td class="end font ligest-gray"> 5,512</td>
                            <td class="end font">11,529</td>
                            <td class="end font ligest-gray">18,521</td>
                            <td class="end font">14,498</td>
                            <td class="end font ligest-gray">2,431</td>
                            <td class="end font">2,351</td>
                        </tr>
                        <tr>
                            <td class="font ">حصص غير مسيطرة</td>
                            <td class="end font ligest-gray">9,369</td>
                            <td class="end font">19,593</td>
                            <td class="end font ligest-gray">8,247</td>
                            <td class="end font">5,802</td>
                            <td class="end font ligest-gray">1,957</td>
                            <td class="end font">1,892</td>
                        </tr>
                        <tr>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font skyBlue ligest-gray ">14,881</td>
                            <td class="end font skyBlue">31,122</td>
                            <td class="end font skyBlue ligest-gray">26,768</td>
                            <td class="end font skyBlue">20,300</td>
                            <td class="end font skyBlue ligest-gray"> 4,388</td>
                            <td class="end font skyBlue">4,243</td>
                        </tr>
                        <tr>
                            <td class="font ">توزيعات نقدية مدفوعة لحصص غير مسيطرة</td>
                            <td class="end font ligest-gray">-</td>
                            <td class="end font">-</td>
                            <td class="end font ligest-gray">(4,376)</td>
                            <td class="end font">(3,666)</td>
                            <td class="end font ligest-gray">(890)</td>
                            <td class="end font">(629)</td>
                        </tr>
                        <tr>
                            <td class="font ">صافي التدفق النقدي الناتج من أنشطة التشغيل</td>
                            <td class="end font ligest-gray">313,350</td>
                            <td class="end font">322,871</td>
                            <td class="end font ligest-gray">16,605</td>
                            <td class="end font">113,242</td>
                            <td class="end font ligest-gray">17,819</td>
                            <td class="end font">17,949</td>
                        </tr>
                        <tr>
                            <td class="font ">صافي التدفق النقدي المستخدم في أنشطة الاستثمار</td>
                            <td class="end font ligest-gray">(144,937)</td>
                            <td class="end font">(163,079)</td>
                            <td class="end font ligest-gray">(25,361)</td>
                            <td class="end font">(49,041)</td>
                            <td class="end font ligest-gray">(13,709) </td>
                            <td class="end font">(8,926)</td>
                        </tr>
                        <tr>
                            <td class="font ">صافي التدفق النقدي (المستخدم في) / <br/>الناتج من أنشطة التمويل</td>
                            <td class="end font ligest-gray">(169,668)</td>
                            <td class="end font">(180,800) </td>
                            <td class="end font ligest-gray">34,287</td>
                            <td class="end font">(23,988)</td>
                            <td class="end font ligest-gray">(4,519)</td>
                            <td class="end font">(4,213)</td>
                        </tr>
                        <tr>
                            <td class="font ">آثر التغيرات في أسعار الصرف على النقد<br/>والنقد المعادل</td>
                            <td class="end font ligest-gray">247</td>
                            <td class="end font">(73)</td>
                            <td class="end font ligest-gray">(550)</td>
                            <td class="end font">(151)</td>
                            <td class="end font ligest-gray">(23)</td>
                            <td class="end font">(12)</td>
                        </tr>
                        <tr>
                            <td class="font ">صافي (النقص) / الزيادة في التدفقات النقدية</td>
                            <td class="end font ligest-gray">(1,255)</td>
                            <td class="end font">(21,008)</td>
                            <td class="end font ligest-gray">21,155</td>
                            <td class="end font">36,547</td>
                            <td class="end font ligest-gray">(1,299) </td>
                            <td class="end font">4,181</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
   </div>
</template>

<script>
export default {

}
</script>

<style>

</style>